// App.js
import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import LoginPage from "./pages/LoginPage";
import ChangePassword from "./pages/ChangePassword";
import ForgotPassword from "./pages/ForgotPassword";
import Layout from "./components/layout/MainLayout";
import ProtectedRoute from "./ProtectedRoute";
import UserManagement from "./pages/UserManagement/UserManagement";
import Organizations from "./pages/Customer/Organizations/Organizations";
import LicensePlans from "./pages/Customer/LicensePlans/LicensePlans";
import CreateOrViewLicense from "./pages/Customer/LicensePlans/CreateOrViewLicense";
import CreateOrViewOrganization from "./pages/Customer/Organizations/CreateOrViewOrganization";
import CategoriesPage from "./pages/MasterManagement/CategoriesPage";
import Signup from "./pages/Customer/Signup/Signup";
import Dashboard from "./pages/Dashboard/Dashboard";
import ServicesPage from "./pages/MasterManagement/ServicesPage";
import LanguagePage from "./pages/MasterManagement/LanguagePage";
import { useUser } from "./components/UserContext";
import Loader from "./CommonComponents/Loader";
import ServiceDetails from "./pages/MasterManagement/ServiceDetails";
import FrameworkPage from "./pages/MasterManagement/FrameworkPage";
import Profile from "./pages/Profile";
import FrameworkCreateOrViewPage from "./pages/MasterManagement/FrameworkCreateOrViewPage";

function AppRoutes() {
  const { currentUser, loading } = useUser();

  // Show loader while user data is being fetched
  if (loading) return <Loader />;

  return (
    <Routes>
      {/* Public routes */}
      <Route path="/login" element={<LoginPage />} />
      <Route path="/change-password" element={<ChangePassword />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />

      {/* Protected routes */}
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Dashboard />} />
        <Route path="/profile" element={<Profile />} />

        {/* Master Management - available to all authenticated users */}
        <Route exact path="/master/categories" element={<CategoriesPage />} />
        <Route exact path="/master/frameworks" element={<FrameworkPage />} />
        <Route exact path="/master/services" element={<ServicesPage />} />
        <Route exact path="/master/services/service-details/:id" element={<ServiceDetails />} />
        <Route exact path="/master/frameworks/create" element={<FrameworkCreateOrViewPage />} />
        <Route exact path="/master/frameworks/view/:id" element={<FrameworkCreateOrViewPage />} />
        <Route exact path="/master/language" element={<LanguagePage />} />


        {/* Super Admin routes */}
        <Route
          exact
          path="/user/management"
          element={currentUser?.zoneinfo === "super_admin" ? <UserManagement /> : <Navigate to="/" />}
        />
        <Route
          exact
          path="/customer/organizations"
          element={currentUser?.zoneinfo === "super_admin" ? <Organizations /> : <Navigate to="/" />}
        />
        <Route
          exact
          path="/customer/organizations/create"
          element={currentUser?.zoneinfo === "super_admin" ? <CreateOrViewOrganization /> : <Navigate to="/" />}
        />
        <Route
          exact
          path="/customer/organizations/view/:id"
          element={currentUser?.zoneinfo === "super_admin" ? <CreateOrViewOrganization /> : <Navigate to="/" />}
        />
        <Route
          exact
          path="/customer/license"
          element={currentUser?.zoneinfo === "super_admin" ? <LicensePlans /> : <Navigate to="/" />}
        />
        <Route
          exact
          path="/customer/license/create"
          element={currentUser?.zoneinfo === "super_admin" ? <CreateOrViewLicense /> : <Navigate to="/" />}
        />
        <Route
          exact
          path="/customer/license/view/:id"
          element={currentUser?.zoneinfo === "super_admin" ? <CreateOrViewLicense /> : <Navigate to="/" />}
        />
        <Route
          exact
          path="/customer/signups"
          element={currentUser?.zoneinfo === "super_admin" ? <Signup /> : <Navigate to="/" />}
        />
      </Route>

      {/* Catch-all route */}
      <Route path="*" element={<Navigate to="/login" />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppRoutes />
    </BrowserRouter>
  );
}

export default App;